export interface IPLocation {
  city: string;
  country: string;
  countryCode: string;
  ip: string;
  latitude: number;
  longitude: number;
  region: string;
  regionCode: string;
  timezone: string;
}
export const useGetUserLocationFromIP: () => Promise<IPLocation> = () => {
  return fetch('https://ipwho.is/')
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return {
        city: data.city,
        country: data.country,
        countryCode: data.country_code,
        ip: data.ip,
        latitude: data.latitude,
        longitude: data.longitude,
        region: data.region,
        regionCode: data.region_code,
        timezone: data.timezone.abbr,
      };
    })
    .catch(() => {
      return {
        city: '',
        country: '',
        countryCode: '',
        ip: '',
        latitude: 0,
        longitude: 0,
        region: '',
        regionCode: '',
        timezone: '',
      };
    });
};
